import React, { useMemo } from 'react';

import { Grid, IconButton } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import { LoadingPage, RecordContextProvider, useRedirect } from 'react-admin';

import { useParams } from 'react-router-dom';

import SanctionMatchInformation from '../../../../../sanction/SanctionMatchInformation';

import useEntityData from '../../../../../../hooks/useEntityData';

import { SanctionListMatches } from '../../../../../../utilities/schemas/sanctionListMatches';

import actions from '../../../../../../constants/actions';

import SanctionAboutIndividual from '../../../../../sanction/SanctionAboutIndividual';
import SanctionNationalIdentifiers from '../../../../../sanction/SanctionNationalIdentifiers';
import SanctionImages from '../../../../../sanction/SanctionImages';
import SanctionSources from '../../../../../sanction/SanctionSources';
import SanctionRelatedEntities from '../../../../../sanction/SanctionRelatedEntities';
import SanctionSanctions from '../../../../../sanction/SanctionSanctions';

const GoBackButton = () => {
  const redirect = useRedirect();

  return (
    <IconButton onClick={() => { redirect('..'); }} size="small">
      <ArrowBackIosIcon color="inherit" fontSize="medium" />
    </IconButton>
  );
};

const SanctionDetails = () => {
  const {
    data,
    isLoading,
  } = useEntityData<SanctionListMatches>({
    source: 'sanction-list',
    getAction: actions.INDIVIDUAL_GET_SANCTION_LIST,
  });

  const { sanctionId } = useParams();

  const currentSanction = useMemo(
    () => data?.potentialMatches.find((match) => match._id === sanctionId),
    [data, sanctionId],
  );

  if (isLoading) {
    return <LoadingPage />;
  }

  return (
    <RecordContextProvider value={{ ...currentSanction, providerName: data?.providerName }}>
      <Grid container spacing={4}>
        <Grid size={12}>
          <GoBackButton />
        </Grid>
        <Grid size={12}>
          <Grid container spacing={6}>
            <Grid size={12}>
              <SanctionMatchInformation />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <Grid container spacing={6}>
                <Grid size={12}>
                  <SanctionAboutIndividual />
                </Grid>
                <Grid size={12}>
                  <SanctionNationalIdentifiers />
                </Grid>
                <Grid size={12}>
                  <SanctionImages />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <Grid container spacing={6}>
                <Grid size={12}>
                  <SanctionSanctions />
                </Grid>
                <Grid size={12}>
                  <SanctionRelatedEntities />
                </Grid>
              </Grid>
            </Grid>
            <Grid size={12}>
              <SanctionSources />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </RecordContextProvider>
  );
};

export default SanctionDetails;
